import type { CustomerListQuery } from '@/api/customers-api'

/**
 * Query keys for the customer module.
 *
 * The list key carries the whole query object, so changing a filter is a different cache entry
 * rather than a mutation of an existing one — which is what lets a page of results survive while
 * the next one is fetched, and what makes "invalidate every list" a single prefix match.
 */
export const customerKeys = {
  all: ['customers'] as const,
  lists: () => [...customerKeys.all, 'list'] as const,
  list: (query: CustomerListQuery) => [...customerKeys.lists(), query] as const,
  details: () => [...customerKeys.all, 'detail'] as const,
  detail: (customerId: string) => [...customerKeys.details(), customerId] as const,
  exposure: (customerId: string) => [...customerKeys.all, 'exposure', customerId] as const,
  mediaBlob: (customerId: string, mediaType: string) =>
    [...customerKeys.all, 'media-blob', customerId, mediaType] as const,
  verificationOverrides: (branchId: string | undefined) =>
    [...customerKeys.all, 'verification-overrides', branchId] as const,
}
